export default "__VITE_ASSET__CDIsxT3Q__"